import { render } from "./CardAlert.vue?vue&type=template&id=7f722f3b&ts=true"
import script from "./CardAlert.vue?vue&type=script&lang=ts"
export * from "./CardAlert.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__